import { render, staticRenderFns } from "./ListInitialTable.vue?vue&type=template&id=1842634b"
import script from "./ListInitialTable.vue?vue&type=script&lang=js"
export * from "./ListInitialTable.vue?vue&type=script&lang=js"
import style0 from "./ListInitialTable.vue?vue&type=style&index=0&id=1842634b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports